(function($) {
	$('.link-option').click(function(event) {
		event.preventDefault();
		var data_id = $(this).attr('data-id');
		var link = $(this);
		var parent_content = $('.content-sidebar');
		var content_active = $('#'+data_id);
		if(content_active.hasClass('active')){
			parent_content.removeClass('active-content');
			$('.col-content').removeClass('active');
			$('.content-sidebar').removeClass('mobile');
			$('body').removeClass('has-sidebar');
		}
		else{
			$('.col-content').removeClass('active');
			content_active.addClass('active');
			parent_content.addClass('active-content');
			$('body').addClass('has-sidebar');
			$('.content-sidebar').removeClass('mobile');
		}
	});
	$('.content-sidebar .close-sidebar').click(function(event) {
		event.preventDefault();
		$('.content-sidebar').removeClass('active-content');
		$('.col-content').removeClass('active');
		$('.content-sidebar').removeClass('mobile');
		$('body').removeClass('has-sidebar');
	});
	// $('.gallery-popup').each(function() { 
	// 	$(this).magnificPopup({
	// 		delegate: 'a', 
	// 		type: 'image',
	// 		gallery: {
	// 			enabled:true
	// 		}
	// 	});
	// });
	$('.popup-youtube').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false
	});
	$('.link-mobile').click(function(event) {
		if (window.innerWidth < 768){
			if($('.content-sidebar').hasClass('active-content')){
				$('.content-sidebar').addClass('mobile');
			}
			else{
				$('.content-sidebar').removeClass('mobile');
			}
		}
	});
	$(window).resize(function(event) {
		if (window.innerWidth >= 768){
			$('.content-sidebar').removeClass('mobile');
		}
	});
})(jQuery);